import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../../store/revisione53.reducers';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { isNilOrEmptyOrZero } from '@shared/helpers/utils.helper';
import { MyVerbale } from '../../../../models/interfaces/revisione.interface';
import { cloneDeep } from 'lodash-es';
import { withInitialValueDebounced } from '@shared/operators/with-initial-value-debounced.operator';
import { getSchedaCoopAgricoleControl } from '../validators/helpers/scheda-coop-agricole-form-validators.helper';

export const setSchedaCoopAgricoleStabilimentoListeners = (form: FormGroup, store: Store<Revisione53State>): void => {
    my_CkStabilimentoPropr(form, store);
};

const my_CkStabilimentoPropr = (form: FormGroup, store: Store<Revisione53State>): void => {
    const sourceControl = getSchedaCoopAgricoleControl(form, 'my_CkStabilimentoPropr');
    const targetControl = getSchedaCoopAgricoleControl(form, 'my_CkStabilimentoInProprieta');

    sourceControl.valueChanges.pipe(withInitialValueDebounced(sourceControl)).subscribe((value: string) => {
        if (!isNilOrEmptyOrZero(value)) {
            targetControl.patchValue(value, { emitEvent: false });
            updateVerbaleOnStore(store, (myVerbale) => {
                const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
                const sez = myVerbaleClone.my_SezioneI__Rilevazione;
                sez.my_SchedaCoopAgricole.my_CkStabilimentoInProprieta = value;
                return myVerbaleClone;
            });
        }
    });
};
